
































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Vue2Filters from 'vue2-filters'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Modal from '@/components/Modal.vue'
import RadioButton from '@/components/RadioButton.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import { EPaymentReceiptType, IHmo } from '@zunta/configurations'

import Input from '@/components/inputs/Input.vue'
import Icon from '@/components/Icon.vue'
import { getDecNumber } from '@/utils/helpers'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  mixins: [Vue2Filters.mixin],
  props: {
    payment: {
      required: true
    }
  },
  components: {
    Icon,
    Input,
    Modal,
    ErrorMessages,
    RadioButton,
    LoaderWrapper
  }
})
export default class RefundPopup extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store);
  refundOptions: any = {
    refundType: 'full'
  };
  amount: number = 0;
  errors: string[] = [];
  receipt: {
    receiptName: string,
    receiptType: EPaymentReceiptType,
    receiptAddress: string
  } | null = null;
  transactions: any[] = [];
  isSaving: boolean = false;
  isLoaded: boolean = false;

  get paymentTransactions () {
    return this.$store.state.payments.transactions
  }

  get currentPayment () {
    return this.$store.state.payments.currentPayment
  }

  get HMOForCurrentPayment (): IHmo {
    return this.currentPayment &&
      this.currentPayment.payment &&
      this.currentPayment.payment.hmo
  }

  get selectedTransactionTotal () {
    if (this.currentPayment && this.currentPayment.payment) {
      return this.currentPayment.payment.amount
    }
    let transactions_sum = this.transactions.reduce((init, t) => {
      const num = isNaN(parseFloat(t.amount)) ? 0 : parseFloat(t.amount)
      return init + num
    }, 0)
    if (this.currentPayment && this.currentPayment.payment && this.currentPayment.payment.includeSurcharge) {
      transactions_sum = getDecNumber(transactions_sum * 0.0295)
    }
    return transactions_sum
  }

  async mounted () {
    await this.paymentsModuleInstance.getPaymentStatusById(this.$props.payment.id)
    if (this.HMOForCurrentPayment) {
      this.paymentsModuleInstance.UPDATE_PAYMENT_TRANSACTIONS([])
    } else {
      await this.paymentsModuleInstance.getPaymentTransactions(this.$props.payment.id)
      this.initTransactions()
    }
    this.amount = this.selectedTransactionTotal
    this.isLoaded = true
  }

  setReciept (receipt: any) {
    this.receipt = receipt
    this.$forceUpdate()
  }

  changeRefundType (type: any) {
    this.refundOptions.refundType = type
    this.initTransactions()
    this.$forceUpdate()
  }

  validate () {
    return this.errors.length === 0
  }

  initTransactions () {
    this.transactions = []
    const items = this.paymentsModuleInstance.transactions
    if (!items || !items.length) {
      this.errors.push('No transactions available')
      return
    }
    Array.isArray(items) && items.forEach(item => {
      const ted = item ? (item.transactionEffectiveDate as any) : null
      if (ted && ted.payerType) {
        this.transactions.push({
          payment: item.payment,
          originalAmount: item.amount,
          payerName: ted.payerType.payer_name,
          payerType: ted.payerType,
          amount: item.amount,
          transactionEffectiveDate: ted.id,
          isCredit: ted.isCredit
        })
      }
    })
  }

  async refund () {
    if (this.isSaving) {
      return
    }
    if (!this.validate()) {
      return
    }
    this.isSaving = true
    let refund = {
      amount: this.amount
    }
    if (this.receipt) {
      refund = {
        ...refund,
        ...this.receipt
      }
    }

    const refundData = {
      refund,
      transactions: this.transactions
    }
    const response: { status: string, message: any, payment?: any, refund?: any } = await this.paymentsModuleInstance.refundPayment({
      paymentId: this.$props.payment.id, refundData
    })

    if (response.status !== 'Failed') {
      this.$locationManager.rememberLocation(this.$route.fullPath)
      if (response.payment && this.$props.payment.resident) {
        return this.$router.push({
          name: 'refund-success',
          params: {
            residentId: this.$props.payment.resident.id.toString(),
            paymentId: response.payment.id.toString()
          }
        })
      } else if (response.payment && this.currentPayment.payment.hmo) {
        return this.$router.push({
          name: 'hmo-payment-approved',
          params: {
            paymentId: response.payment.id.toString()
          },
          query: {
            refund: 'true'
          }
        })
      }
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: response.message.join('\n'),
        header: 'Process Refund',
        icon: 'warning'
      })
    }
    this.isSaving = false
  }
}
